'use client';
import React from 'react';
import styled from '@benzinga/themetron';

import type { BenzingaLogoVariant } from '../BenzingaLogo';

interface BenzingaFrLogoProps {
  variant: BenzingaLogoVariant | undefined;
}
export const BenzingaFrLogo: React.FC<BenzingaFrLogoProps> = ({ variant }) => {
  const fillColors: string[] = variant === 'light' ? ['#093451', '#fdfdfd', '201px'] : ['#fdfdfd', '#1d2c42', '501px'];
  return (
    <IconWrapper>
      <svg
        baseProfile="tiny"
        height="100%"
        id="Layer_1"
        overflow="visible"
        version="1.2"
        viewBox="0 0 300 43"
        width={fillColors[2]}
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect fill={fillColors[0]} height="100%" width="100%" />
        <g>
          <g>
            <polygon
              fill={fillColors[1]}
              points="29.5,34.1 47.3,34.1 47.3,29.4 34.9,29.4 34.9,23.6 45.2,23.6 45.2,19 34.9,19 34.9,13.7
			47.4,13.7 47.4,9 29.5,9 		"
            />
            <polygon
              fill={fillColors[1]}
              points="68.5,24.7 56.9,8.9 48.9,8.9 51.4,12.1 51.4,34.1 56.7,34.1 56.7,17.6 68.7,34 73.9,34 73.9,8.9
			68.5,8.9 		"
            />
            <path
              d="M22.4,21.2c2.3-0.5,4.3-2.6,4.3-5.7c0-3.3-2.4-6.4-7.2-6.4H3.9l2.4,3.1v22H20c4.8,0,7.3-3,7.3-6.8
			C27.2,24.2,25.1,21.5,22.4,21.2z M11.7,13.7h6.6h0.2c1.8,0,2.9,1.1,2.9,2.6c0,1.6-1.1,2.6-2.9,2.6h-6.7V13.7z M18.6,29.4h-6.9
			v-5.7h6.9c2,0,3.2,1.3,3.2,2.9C21.8,28.3,20.6,29.4,18.6,29.4z"
              fill={fillColors[1]}
            />
            <path
              d="M147.1,24.8h2.8v2.9c-1,0.9-3,1.9-5.1,1.9c-4.5,0-7.6-3.4-7.6-8c0-4.6,3.2-8,7.6-8c2.6,0,4.6,1.4,5.7,3.2
			l4.2-2.3c-1.8-2.9-5-5.4-10-5.4c-7.1,0-13,4.9-13,12.5s5.8,12.5,13,12.5c4.4,0,7.9-1.8,10.3-4.5v-9.3h-11.5L147.1,24.8z"
              fill={fillColors[1]}
            />
            <polygon
              fill={fillColors[1]}
              points="124.1,24.7 112.5,8.9 104.5,8.9 107,12.1 107,34.1 112.3,34.1 112.3,17.6 124.3,34 129.5,34
			129.5,8.9 124.1,8.9 		"
            />
            <path
              d="M172.3,8.9h-10.3l2.5,3.2l-0.5,1.2l-8,20.8h6l1.6-4.2h5.3h5.5l1.6,4.2h6L172.3,8.9z M164.9,25.1l3.9-10.8
			l3.9,10.8h-4H164.9z"
              fill={fillColors[1]}
            />
            <rect fill={fillColors[1]} height="25.1" width="5.4" x="97.5" y="8.9" />
            <polygon
              fill={fillColors[1]}
              points="95.2,13.3 95.2,9 76.1,9 76.1,13.7 88,13.7 76.1,29.8 76.1,34.1 95.2,34.1 95.2,29.4 83.1,29.4
			"
            />
          </g>
          <rect fill="#E4E5E4" height="21.2" width="1.3" x="198.3" y="11" />
          <g>
            <path d="M213.5,28.9V14.3h10v2.5h-7.1v3.5h6.1v2.5h-6.1v6.2H213.5z" fill="#EC2027" />
            <path
              d="M225.9,28.9V14.3h6.2c1.6,0,2.7,0.1,3.4,0.4c0.7,0.3,1.3,0.7,1.7,1.4c0.4,0.7,0.6,1.4,0.6,2.3
			c0,1.1-0.3,2-1,2.7c-0.6,0.7-1.6,1.2-2.9,1.4c0.6,0.4,1.2,0.8,1.6,1.2c0.4,0.4,1,1.2,1.7,2.4l1.8,2.9h-3.5l-2.1-3.2
			c-0.8-1.1-1.3-1.9-1.6-2.2c-0.3-0.3-0.6-0.5-0.9-0.6c-0.3-0.1-0.8-0.2-1.5-0.2h-0.6v6.1H225.9z M228.9,20.5h2.2
			c1.4,0,2.3-0.1,2.7-0.2c0.4-0.1,0.6-0.3,0.8-0.6c0.2-0.3,0.3-0.7,0.3-1.1c0-0.5-0.1-0.9-0.4-1.2c-0.3-0.3-0.6-0.5-1.1-0.6
			c-0.2,0-1,0-2.2,0h-2.3V20.5z"
              fill="#EC2027"
            />
            <path
              d="M253.9,28.9h-3.2l-1.3-3.3h-5.8l-1.2,3.3h-3.1l5.7-14.6h3.1L253.9,28.9z M248.4,23.1l-2-5.4l-2,5.4H248.4z
			"
              fill="#EC2027"
            />
            <path d="M255.5,28.9V14.3h2.9l6,9.8v-9.8h2.7v14.6h-3l-5.9-9.5v9.5H255.5z" fill="#EC2027" />
            <path
              d="M279.6,23.5l2.9,0.9c-0.4,1.6-1.2,2.8-2.2,3.6c-1,0.8-2.3,1.2-3.9,1.2c-1.9,0-3.5-0.7-4.8-2
			c-1.3-1.3-1.9-3.1-1.9-5.4c0-2.4,0.6-4.3,1.9-5.7c1.3-1.3,2.9-2,5-2c1.8,0,3.2,0.5,4.4,1.6c0.7,0.6,1.2,1.5,1.5,2.7l-2.9,0.7
			c-0.2-0.8-0.5-1.4-1.1-1.8c-0.5-0.4-1.2-0.7-2-0.7c-1.1,0-2,0.4-2.6,1.2c-0.7,0.8-1,2-1,3.8c0,1.8,0.3,3.2,1,4
			c0.7,0.8,1.5,1.2,2.6,1.2c0.8,0,1.5-0.2,2-0.7C278.9,25.4,279.3,24.6,279.6,23.5z"
              fill="#EC2027"
            />
            <path d="M285,28.9V14.3h10.8v2.5h-7.9V20h7.3v2.5h-7.3v4h8.2v2.5H285z" fill="#EC2027" />
          </g>
        </g>
      </svg>
    </IconWrapper>
  );
};

const IconWrapper = styled.span`
  &.benzinga-logo {
    display: inline-block;
  }
`;

export default BenzingaFrLogo;
